//************************************************************************ /
// CARD COMMENT
// Displays a comment from a user within a Story Card.
//************************************************************************ /

import React from "react";
import anim from "../../styles/animations.module.scss";
import {
  Avatar,
  Group,
  Typography,
} from "@dreambigger/design-system/src/components";
import { generateCloudinaryUrl } from "../../../../utils";
import { calculateTimePast } from "../../../../dates/calculate-days-past";
import { StoryUser, User } from "../../../../types";

const { Text } = Typography;

export interface CardCommentProps {
  user: User | StoryUser;
  timestamp: string;
  comment: string;
  animate?: boolean;
}

const CardComment = ({
  user,
  timestamp,
  comment,
  animate = false,
}: CardCommentProps) => {
  const userInitials = (
    (user?.firstName[0] ?? "") + (user?.lastName[0] ?? "")
  ).toUpperCase();

  const hasStoryUserImage =
    user?.imageId &&
    user?.imageVersion &&
    // We don't want to use the default avatar image that is saved to users.
    user?.imageId !== "avatar";

  return (
    <Group
      xs="horizontal"
      spacing={3}
      className={`pt-3 ${animate && anim.newComment}`}
    >
      {/* User Avatar */}
      <Avatar
        className="flex-shrink-0"
        size="large"
        alt="story user avatar"
        src={
          hasStoryUserImage &&
          generateCloudinaryUrl(user.imageVersion, user.imageId, {
            type: "avatar",
          })
        }
      >
        {!hasStoryUserImage && userInitials}
      </Avatar>
      <Group id="authorAndDate" spacing={1}>
        {/* Posted X days ago */}
        <Text className="f-2 lh-2 gray-8">
          {user.firstName} {user.lastName} |{" "}
          {calculateTimePast(new Date(timestamp))}
        </Text>
        {/* Comment */}
        <Text
          className="f-2"
          style={{ whiteSpace: "pre-line", overflowWrap: "anywhere" }}
        >
          {comment}
        </Text>
      </Group>
    </Group>
  );
};
export default CardComment;
